import { render, staticRenderFns } from "./SearchLocationSuggestions.vue?vue&type=template&id=23ea2c5b&"
import script from "./SearchLocationSuggestions.vue?vue&type=script&lang=js&"
export * from "./SearchLocationSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports